<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.subtitle }}</p>
  @for (status of data.status; track status.color) {
    <div class="status-legends">
      <mat-icon fontIcon="square" [style]="{ color: '#' + status.color }"></mat-icon>
      <p>{{ status.explanation }}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button class="close" matButton type="button" (click)="close()">CLOSE</button>
</mat-dialog-actions>
